import $ from 'jquery';
import CSRF from 'lib/csrf';
import Callbacks from 'lib/callbacks.js';

class Counter {
    _count = undefined;

    constructor(opts = {}) {
        this.opts = opts;
    }

    init(element) {
        if (!element || !element.length) {
            return;
        }

        if (!this.opts.selector) {
            return;
        }

        this.element = element.find(this.opts.selector);

        if (!this.element.length) {
            this.element = null;
            return;
        }

        const val = this.element.html() || '';

        this.count = val.trim();
    }

    get count() {
        return this._count || 0;
    }

    set count(value) {
        if (!this.element) {
            return;
        }

        try {
            this._count = parseInt(value, 10);
            this.element.html(value);
        } catch (err) {
            console.error(err);
            this._count = 0;
            this.element.html('0');
        }
    }

    inc() {
        this.count = this.count + 1;
    }

    dec() {
        let count = this.count;

        this.count = --count > 0 ? count : 0;
    }
}

/**
 * Класс добавления поста в избранное
 * @param  {object}  options
 */
class Favorites {
    _isLoading = false; // флаг отправки данных на сервер

    constructor(options = {}, events = {}) {
        console.log('Favorites', options);
        this._$el = options.$el;
        this._articleId = options.id;
        this._activeClass = options.activeClass;
        this._url = options.url;

        this.events = new Callbacks(events);
        this.counter = new Counter({
            selector: options.counterBoxSelector,
        });

        this._init();
    }

    _init() {
        this.counter.init(this._$el);
        this._isFavorite = this._$el.hasClass(this._activeClass);
    }

    addToFavorites() {
        if (!this._isLoading) {
            this._sendToServer();
        }
    }

    /**
     * Отправка данных на сервер
     */
    _sendToServer() {
        let sendData = Object.assign(CSRF.getByObject(), {
            postId: this._articleId,
        });
        const updatedData = this.events.trigger('beforeSend', {
            sendData,
            el: this._$el,
        });

        if (updatedData) {
            sendData = updatedData;
        }

        $.ajax({
            url: this._url,
            data: sendData,
            dataType: 'json',
            method: 'POST',
            beforeSend: () => {
                this._isLoading = true;
                this._toggleRecountAndActivate();
            },
            success: (serverResponse) => {
                const { status, response } = serverResponse;

                if (status === 'ok') {
                    this.counter.count = response.count;
                    this._isFavorite = response.isFavorite;
                    this._toggleFavorite();
                }
            },
            error: (err) => {
                console.log(err);
                this._toggleRecountAndActivate();
            },
            complete: () => {
                this._isLoading = false;
            },
        });
    }

    /**
     * Функция изменения количества и выделения при добавлении в избранное
     */
    _toggleRecountAndActivate() {
        if (this._toggleFavoriteState()) {
            this.counter.inc();
        } else {
            this.counter.dec();
        }

        this._toggleFavorite();
    }

    /**
     * Функция отображения добавления/удаления в избранное
     */
    _toggleFavorite() {
        if (this._isFavorite) {
            this._$el.addClass(this._activeClass);
            this.events.trigger('activate', this._$el);
        } else {
            this._$el.removeClass(this._activeClass);
            this.events.trigger('deactivate', this._$el);
        }
    }

    /**
     * Управление состоянием флажка _isFavorite
     * @return {bool}        добавлен ли пост в избранное
     */
    _toggleFavoriteState() {
        if (this._isFavorite) {
            this._isFavorite = false;
        } else {
            this._isFavorite = true;
        }

        return this._isFavorite;
    }
}

/**
 * Класс управления избранным
 * @param  {object}      options
 */
export default class ManageFavorites {
    constructor(options) {
        this._$el = $(options.el);
        this._btnSelector = options.btnSelector;
        this._activeClass = options.activeClass;
        this._counterBoxSelector = options.counterBoxSelector;
        this._url = options.url;
    }

    init(events = {}) {
        this._events = events;
        this._favorites = {};

        $(this._$el).on('click', this._btnSelector, this._onClickFavButton);
    }

    /**
     * Обработчик нажатия на кнопку добавления в избранное
     *
     * @param  {object} event
     */
    _onClickFavButton = (event) => {
        const $favBtn = $(event.currentTarget);
        const id = $favBtn.data('article-id');

        if (!id) {
            console.warn('Article ID not found');
            return;
        }

        if (this._favorites[`article${id}`]) {
            this._favorites[`article${id}`].addToFavorites();
            return;
        }

        this._favorites[`article${id}`] = new Favorites(
            {
                id,
                $el: $favBtn,
                activeClass: this._activeClass,
                counterBoxSelector: this._counterBoxSelector,
                url: this._url,
            },
            this._events
        );
        this._favorites[`article${id}`].addToFavorites();
    };

    /**
     * Очистка
     */
    destroy() {
        this._favorites = {};
        $(this._$el).off('click', this._btnSelector, this._onClickFavButton);
    }
}
